import React from "react";

export default function Logo({ width = "40", height = "60", color = "#4f4f4f" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 60 90`}
      fill='#4f4f4f'
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1765:1686)">
        <path
          d="M60 60.502H0V0H60V60.502ZM3.46614 57.0069H56.5339V3.49514H3.46614V57.0069Z"
          fill={color}
        />
        <path
          d="M60 89.0003H0V57.0072H60V89.0003ZM3.46614 85.5052H56.5339V60.5023H3.46614V85.5052Z"
          fill={color}
        />
        <path
          d="M15.0925 70.0886H16.994V72.2909H19.2323V70.0886H21.1338V76.1585H19.2323V73.6714H16.994V76.1585H15.0925V70.0886Z"
          fill={color}
        />
        <path
          d="M29.272 73.1131C29.272 74.8223 28.1528 76.3015 25.8058 76.3015C23.6544 76.3015 22.4592 74.899 22.4592 73.1241C22.4592 71.4587 23.6327 69.9576 25.8928 69.9576C28.0659 69.9576 29.272 71.4039 29.272 73.1131ZM24.4585 73.0912C24.4585 74.154 24.8931 74.9429 25.8928 74.9429C26.925 74.9429 27.2618 74.0335 27.2618 73.1241C27.2618 72.0723 26.8815 71.2834 25.8384 71.2834C24.8605 71.2834 24.4585 72.1051 24.4585 73.0912Z"
          fill={color}
        />
        <path
          d="M36.1941 74.0878C36.1941 73.1126 36.2049 71.9622 36.2484 71.25H36.2375C35.9442 72.4224 35.553 74.0001 34.9337 76.1585H33.3581C32.8801 74.1644 32.4672 72.4552 32.1629 71.2391H32.1521C32.1847 71.9512 32.2607 73.1126 32.2607 74.1535V76.1585H30.5657V70.0886H33.2821C33.695 71.5349 34.0861 73.025 34.26 74.022H34.2709C34.499 72.9592 34.9011 71.5458 35.3248 70.0886H38.0412V76.1585H36.1941V74.0878Z"
          fill={color}
        />
        <path
          d="M44.7885 73.737H41.5614V74.7888H45.1688L44.9515 76.1694H39.6816V70.0994H44.9623V71.48H41.5614V72.3565H44.7885V73.737Z"
          fill={color}
        />
        <path
          d="M11.506 21.2305H21.8935C26.3919 21.2305 28.3368 23.4327 28.3368 26.1061C28.3368 28.2974 26.9786 29.6013 25.5335 30.1491C27.3481 30.7188 29.0214 32.1322 29.0214 34.5317C29.0214 38.0816 26.3158 40.1634 21.7197 40.1634H11.4951V21.2305H11.506ZM20.9373 28.648C22.9801 28.648 23.632 27.8373 23.632 26.6868C23.632 25.2625 22.5563 24.6818 20.9808 24.6818H15.9826V28.648H20.9373ZM15.9826 36.7449H21.1329C22.8932 36.7449 24.2188 36.23 24.2188 34.3564C24.2188 32.8444 23.1974 32.0665 21.2199 32.0665H15.9826V36.7449Z"
          fill={color}
        />
        <path
          d="M37.5728 40.1634V33.3922C37.5728 33.1402 37.4967 33.0088 37.3446 32.7787L29.5757 21.2305H34.9868C36.8231 24.1997 39.1374 27.8044 40.0393 29.5903C40.9955 27.8263 43.3533 24.1997 45.2005 21.2305H50.166L42.2667 32.9649C42.1581 33.1183 42.1581 33.2279 42.1581 33.4689V40.1634H37.5728Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1765:1686">
          <rect width={width} height={height} fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
}
